module.exports = "<button class=\"btn btn-secondary search\" (click)=\"searchfn.emit()\">Search</button>"